var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useAppSelector } from "@/hooks/store";
import { widgetSortOrderAsc } from "@/utils/funcs";
import { Slot } from "@/utils/types/layout";
import { useMemo } from "react";
export function useSlotComponents() {
    var headerStartComponents = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.HEADER_START].widgets;
    });
    var orderedHeaderStartComponents = useMemo(function () { return __spreadArray([], headerStartComponents, true).sort(widgetSortOrderAsc); }, [headerStartComponents]);
    var headerCenterComponents = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.HEADER_CENTER].widgets;
    });
    var orderedHeaderCenterComponents = useMemo(function () { return __spreadArray([], headerCenterComponents, true).sort(widgetSortOrderAsc); }, [headerCenterComponents]);
    var headerEndComponents = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.HEADER_END].widgets;
    });
    var orderedHeaderEndComponents = useMemo(function () { return __spreadArray([], headerEndComponents, true).sort(widgetSortOrderAsc); }, [headerEndComponents]);
    var footerStartComponents = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.FOOTER_START].widgets;
    });
    var orderedFooterStartComponents = useMemo(function () { return __spreadArray([], footerStartComponents, true).sort(widgetSortOrderAsc); }, [footerStartComponents]);
    var footerCenterComponents = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.FOOTER_CENTER].widgets;
    });
    var orderedFooterCenterComponents = useMemo(function () { return __spreadArray([], footerCenterComponents, true).sort(widgetSortOrderAsc); }, [footerCenterComponents]);
    var footerEndComponents = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.FOOTER_END].widgets;
    });
    var orderedFooterEndComponents = useMemo(function () { return __spreadArray([], footerEndComponents, true).sort(widgetSortOrderAsc); }, [footerEndComponents]);
    var menuComponentsNorth = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.MENU_NORTH].widgets;
    });
    var orderedMenuComponentsNorth = useMemo(function () { return __spreadArray([], menuComponentsNorth, true).sort(widgetSortOrderAsc); }, [menuComponentsNorth]);
    var menuComponentsWest = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.MENU_WEST].widgets;
    });
    var orderedMenuComponentsWest = useMemo(function () { return __spreadArray([], menuComponentsWest, true).sort(widgetSortOrderAsc); }, [menuComponentsWest]);
    var menuComponentsEast = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.MENU_EAST].widgets;
    });
    var orderedMenuComponentsEast = useMemo(function () { return __spreadArray([], menuComponentsEast, true).sort(widgetSortOrderAsc); }, [menuComponentsEast]);
    var componentsDockWest = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.DOCK_WEST].widgets;
    });
    var orderedComponentsDockWest = useMemo(function () { return __spreadArray([], componentsDockWest, true).sort(widgetSortOrderAsc); }, [componentsDockWest]);
    var componentsDockEast = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.DOCK_EAST].widgets;
    });
    var orderedComponentsDockEast = useMemo(function () { return __spreadArray([], componentsDockEast, true).sort(widgetSortOrderAsc); }, [componentsDockEast]);
    var componentsDockNorth = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.DOCK_NORTH].widgets;
    });
    var orderedComponentsDockNorth = useMemo(function () { return __spreadArray([], componentsDockNorth, true).sort(widgetSortOrderAsc); }, [componentsDockNorth]);
    var componentsDockSouth = useAppSelector(function (_a) {
        var layout = _a.layout;
        return layout.slots[Slot.DOCK_SOUTH].widgets;
    });
    var orderedComponentsDockSouth = useMemo(function () { return __spreadArray([], componentsDockSouth, true).sort(widgetSortOrderAsc); }, [componentsDockSouth]);
    return {
        orderedHeaderStartComponents: orderedHeaderStartComponents,
        orderedHeaderCenterComponents: orderedHeaderCenterComponents,
        orderedHeaderEndComponents: orderedHeaderEndComponents,
        orderedFooterStartComponents: orderedFooterStartComponents,
        orderedFooterCenterComponents: orderedFooterCenterComponents,
        orderedFooterEndComponents: orderedFooterEndComponents,
        orderedMenuComponentsNorth: orderedMenuComponentsNorth,
        orderedMenuComponentsWest: orderedMenuComponentsWest,
        orderedMenuComponentsEast: orderedMenuComponentsEast,
        orderedComponentsDockWest: orderedComponentsDockWest,
        orderedComponentsDockEast: orderedComponentsDockEast,
        orderedComponentsDockNorth: orderedComponentsDockNorth,
        orderedComponentsDockSouth: orderedComponentsDockSouth,
    };
}
